import { render, staticRenderFns } from "./AffiliateReportsLanding.vue?vue&type=template&id=206726da&"
import script from "./AffiliateReportsLanding.vue?vue&type=script&lang=js&"
export * from "./AffiliateReportsLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports